<template lang="html">
  <div class="dialog-mask" v-show="innerShow" >
    <div class="activity-dialog">
      <div class="dialog-header">
        <span class="dialog-title">{{ $t('选择任务') }}</span>
        <span class="icon-close" @click="close"></span>
      </div>
      <div class="dialog-content">
        <div class="activity-lists">
          <div class="activity-item" :class="{'active': item.id == activity.id}"
            v-for="(item,index) in activityLists"
            :key="item.id"
            @click="selectCurrentActivity(item)"
          >
            <div class="activity-left">
              <span class="single-checkbox" :class="{'active-single-checkbox': item.id == activity.id}"></span>
            </div>
            <div class="activity-middle">
              <img class="activity-img" :src="item.cover.filePath" alt="" />
            </div>
            <div class="activity-right">
              <div class="activity-right-content">
                <span class="activity-title">{{item.title}}</span>
                <!-- <span class="activity-period">2024.7.10-2024.7.20截止</span> -->
                <span class="activity-score">{{item.minScore}}-{{item.maxScore}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="dialog-button cancel" @click="close">
          {{ $t('取消') }}
        </div>
        <div class="dialog-button confirm" @click="submit">
          {{ $t('确定') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEffectiveActivity
} from "@/api/index";
export default {
  name: "activitydialog",
  props: {
    show: {
      type: Boolean,
      default(){
        return false
      }
    },
    data: {
      type: Object,
      default(){
        return {};
      }
    }
  },
  data(){
    return {
      innerShow: false,
      activity: this.data||{},
      activityLists: []
    }
  },
  watch: {
    show(newVal){
      this.innerShow = this.show;
    },
    innerShow: {
      handler(newV, oldV){
        if(newV){
          document.body.style.overflow = "hidden";
        }
        else{
          document.body.style.overflow = "auto";
        }
      },
      immediate: true,
      deep: true
    },
    data: {
      handler(newV, oldV){
        if(newV){
          this.activity = newV;
        }
      },
      immediate: true,
      deep: true
    }
  },
  created(){
    this.$nextTick(()=>{
      this._getEffectiveActivity();
    });
  },
  methods: {
    // 获取所有关联活动
    async _getEffectiveActivity(){
      let result = {};
      result = await getEffectiveActivity()||{};
      if(result.code == 200){
        let data = result.data || [];
        data = data.map(item=>{
          let obj = {};
          for(let key in item){
            obj[key] = item[key];
          }
          obj["cover"] = item["cover"] || {};

          return obj;
        });
        this.activityLists = data;
      }
    },
    // 选择当前活动
    selectCurrentActivity(data){
      data = data || {};
      let currentId = data.id || "";
      let activity = this.activity;
      let activityId = activity.id;
      if(currentId == activityId){
        this.activity = {};
      }
      else{
        this.activity = data;
      }
    },

    // 关闭
    close(){
      this.innerShow = false;
      this.$emit("update:show",this.innerShow);
    },

    // 提交
    submit(){

      this.$emit("confirm",{
        data: this.activity,
        show: false
      })
    },
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~@/common/stylus/mixin.styl";
.dialog-mask
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(0,0,0,0.7)
  z-index: 10000
  .activity-dialog
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%,-50%)
    width: 3.69rem
    height: 4.75rem
    border-radius: 0.13rem
    border: 1px solid #F3F3F3
    box-sizing: border-box
    background-color: #FFFFFF
    overflow: hidden
    .dialog-header
      position: relative
      height: 0.43rem
      display: flex
      align-items: center
      justify-content: center
      &::after
        content: " "
        position: absolute
        left: 0
        right: 0
        bottom: 0
        width: 100%
        height: 1px
        background-repeat: no-repeat
        background-size: 100% 100%
        bg-image("~@/images/bg/1px-line-bg")
      .dialog-title
        font-size: 0.17rem
        color: #191919
      .icon-close
        position: absolute
        right: 0.22rem
        top: 50%
        transform: translate(0, -50%)
        width: 0.13rem
        height: 0.13rem
        background-repeat: no-repeat
        background-size: 100% 100%
        bg-image("~@/images/icon/icon-close")
    .dialog-content
      position: absolute
      top: 0.43rem
      bottom: 0.36rem
      left: 0
      right: 0
      width: 100%
      padding: 0.23rem 0 0.2rem 0
      box-sizing: border-box
      .activity-lists
        display: flex
        flex-direction: column
        height: 100%
        overflow-y: auto
        .activity-item
          margin-bottom: 0.21rem
          width: 100%
          height: 0.87rem
          display: flex
          align-items: center
          background-repeat: no-repeat
          background-size: 100% 100%
          cursor: pointer
          &.active
            bg-image("~@/images/bg/activity-shadow-bg")
          .activity-left
            width: 0.78rem
            display: flex
            align-items: center
            .single-checkbox
              position: relative
              margin-left: 0.36rem
              width: 0.13rem
              height: 0.13rem
              display: inline-block
              border-radius: 50%
              background-repeat: no-repeat
              background-size: 100% 100%
              bg-image("~@/images/bg/circle-radio-single-bg")
              &.active-single-checkbox
                bg-image("~@/images/bg/circle-radio-check-bg")
                &::after
                  content: " "
                  position: absolute
                  top: 50%
                  left: 50%
                  transform: translate(-50%, -50%)
                  width: 0.1rem
                  height: 0.08rem
                  background-repeat: no-repeat
                  background-size: 100% 100%
                  bg-image("~@/images/icon/icon-white-check")
          .activity-middle
            width: 1.21rem
            height: 0.67rem
            .activity-img
              display: inline-block
              width: 1.21rem
              height: 0.67rem
              border-radius: 0.04rem
          .activity-right
            padding-left: 0.06rem
            flex: 1
            box-sizing: border-box
            display: flex
            align-items: center
            .activity-right-content
              display: flex
              flex-direction: column

              .activity-title
                margin-bottom: 0.12rem
                width: 100%
                font-size: 0.11rem
                color: #181818
              .activity-score
                font-size: 0.11rem
                color: #575656
              .activity-period
                font-size: 0.11rem
                color: #575656

    .dialog-footer
      position: absolute
      bottom: 0
      left: 0
      right: 0
      width: 100%
      height: 0.36rem
      display: flex
      justify-content: center
      .dialog-button
        margin-right: 38px
        width: 0.72rem
        height: 0.32rem
        border-radius: 0.07rem
        box-sizing: border-box
        display: flex
        align-items: center
        justify-content: center
        font-size: 0.14rem
        cursor: pointer
        &:last-child
          margin-right: 0
        &.cancel
          color: #181818
          background-color: #FFFFFF
          border: 1px solid #ADADAD
        &.confirm
          color: #F3F3F3
          background-color: #D2BE68

</style>
